<template>
  <div class="grid grid-cols-2 gap-2 md:grid-cols-8 md:gap-6 xl:grid-cols-12">
    <EditableComponent
      v-for="childContent in mapNodes(content)"
      :key="childContent['id']"
      :content="childContent"
    />
  </div>
</template>

<script setup>
import { EditableComponent } from "@magnolia/vue-editor";
import { mapNodes } from "~/utils/helper/magnolia";

defineProps(["content"]);
</script>
